// extracted by mini-css-extract-plugin
export var gif = "_gh-0";